{
  "contact-update-dialog": {
    "buttons": {
      "confirm": "Xác nhận",
      "skip": "Bỏ qua"
    },
    "text": {
      "confirm-email": "Xác nhận email",
      "confirm-email-hint": "Vui lòng xác nhận email của bạn",
      "confirm-phone-number": "Xác nhận số điện thoại",
      "confirm-phone-number-hint": "Vui lòng xác nhận số điện thoại của bạn",
      "enter-email": "Email bị thiếu",
      "enter-email-hint": "Vui lòng điền email của bạn",
      "enter-phone-number": "Số điện thoại bị thiếu",
      "enter-phone-number-hint": "Vui lòng điền số điện thoại của bạn",
      "in-second": "sau {{seconds}} giây"
    }
  }
}
